import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.makeReportNorm.success: {
            return action.payload;
        }

        case constants.makeReportNorm.try:
        case constants.makeReportNorm.error: {
            return initialState;
        }

        default:
            return state;
    }
}